<template lang="pug">
  el-dropdown(trigger='click')
    el-button(type='primary', size="small")
      font-awesome-icon(icon="file-export", size="lg").el-icon--left
      | {{ label || 'Ações'}}
      i.el-icon-arrow-down.el-icon--right
    el-dropdown-menu(slot='dropdown')
      template(v-for="acao in acoes")
        el-dropdown-item(v-if="acao.active")
          .flex(@click="acao.click")
            font-awesome-icon(:icon="acao.icon", size="lg")
            | &nbsp {{acao.title}}
</template>

<script>
export default {
  props: {
    acoes: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

  .label {
    padding-bottom: 5px;
    font-size: 14px;

    .required{
      color: $error;
    }
  }

  p {
    color:$font-dark-color !important;
    font-size:14px;
  }

  .flex {
    display: flex;
    align-items: center;
    justify-content: left;
  }

  .material-icons {
    width: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/ButtonAcoesListagem.vue